import { render, staticRenderFns } from "./contentLiveReport.vue?vue&type=template&id=06616fac&"
import script from "./contentLiveReport.vue?vue&type=script&lang=js&"
export * from "./contentLiveReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports